export const GA4_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

/**
 * Reads a single GA4 field from the active gtag instance.
 *
 * @param {string} fieldName
 * @returns {Promise<string|null>}
 */
function getGtagField(fieldName) {
  return new Promise((resolve) => {
    if (!window.gtag) {
      resolve(null);
      return;
    }

    try {
      window.gtag("get", GA4_MEASUREMENT_ID, fieldName, (value) => {
        resolve(typeof value === "string" && value.trim() ? value.trim() : null);
      });
    } catch (_error) {
      resolve(null);
    }
  });
}

/**
 * Reads the GA4 browser identifiers needed for backend-owned critical events.
 *
 * @returns {Promise<{ clientId: string|null, sessionId: string|null }>}
 */
export async function getCriticalAnalyticsIdentifiers() {
  const [clientId, sessionId] = await Promise.all([
    getGtagField("client_id"),
    getGtagField("session_id"),
  ]);

  return { clientId, sessionId };
}

export const customEvent = ({
  name,
  label,
  category,
  action = "click",
  data = {},
}) => {
  if (!window.gtag) return;
  if (process.env.NODE_ENV !== "production") return;
  const newData = {
    date: new Intl.DateTimeFormat("en-US", {
      dateStyle: "full",
      timeStyle: "long",
      timeZone: "America/Los_Angeles",
    }).format(new Date()),
    userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    ...data,
  };
  window.gtag("event", name, {
    event_category: category,
    event_action: action,
    event_label: label,
    ...newData,
  });
};
